<template>
  <div :class="$style.wrap">
    <p :class="$style.section">Планировки</p>
    <div v-for="(l, i) in items" :key="l.key" :class="$style.item">
      <div :class="$style.head">
        <img :src="l.preview" alt="" :class="$style.thumb" />
        <div :class="$style.headtext">
          <p :class="$style.caption">{{ caption(l) }}</p>
          <button :class="$style.remove" @click="remove(i)">Удалить</button>
        </div>
      </div>
      <div :class="$style.grid">
        <label :class="$style.lbl">
          <span>Тип</span>
          <select v-model="l.kind" :class="$style.inp">
            <option v-for="k in kinds" :key="k" :value="k">{{ k }}</option>
          </select>
        </label>
        <label :class="$style.lbl">
          <span>Площадь, м²</span>
          <input
            v-model="l.area"
            type="text"
            inputmode="decimal"
            placeholder="25,4"
            :class="$style.inp"
          />
        </label>
        <label :class="$style.lbl">
          <span>Цена, ₽</span>
          <input
            v-model="l.price"
            type="text"
            inputmode="numeric"
            placeholder="14 633 766"
            :class="$style.inp"
            @input="l.price = fmt(l.price)"
          />
        </label>
        <label :class="$style.lbl">
          <span>Скидка, %</span>
          <input
            v-model="l.discount"
            type="text"
            inputmode="numeric"
            placeholder="0"
            :class="$style.inp"
          />
        </label>
        <label :class="$style.lbl">
          <span>Корпус</span>
          <input v-model="l.building" type="text" placeholder="2" :class="$style.inp" />
        </label>
        <label :class="$style.lbl">
          <span>Этаж</span>
          <input v-model="l.floor" type="text" placeholder="2/23" :class="$style.inp" />
        </label>
        <label :class="[$style.lbl, $style.full]">
          <span>Вид</span>
          <input v-model="l.view" type="text" placeholder="на парк" :class="$style.inp" />
        </label>
      </div>
    </div>
    <div :class="$style.custom">
      <label :for="inputId" :class="$style.custom_button">
        <img src="../assets/img/add_photo.svg" alt="" :class="$style.img" />Добавить планировку
      </label>
      <input
        :id="inputId"
        type="file"
        accept="image/*"
        multiple
        :class="$style.hidden"
        @change="add"
      />
    </div>
  </div>
</template>

<script>
const KINDS = ['Студия', '1-к', '2-к', '3-к', '4-к', '5-к', 'Пентхаус', 'Коммерция'];
const SHORT = {
  Студия: 'ст',
  Пентхаус: 'пентхаус',
  Коммерция: 'комм.',
};
let seq = 0;

export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    inputId: { type: String, default: 'layout_files' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      kinds: KINDS,
      items: this.modelValue.map((l) => ({ ...l, key: l.key || 'k' + seq++ })),
    };
  },
  watch: {
    items: {
      deep: true,
      handler(v) {
        this.$emit('update:modelValue', v);
      },
    },
  },
  methods: {
    fmt(v) {
      const d = String(v || '').replace(/\D/g, '');
      return d.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    caption(l) {
      const k = SHORT[l.kind] || l.kind || '';
      return l.area ? `${k} ${String(l.area).replace('.', ',')} м²` : k || 'Новая планировка';
    },
    add(e) {
      Array.from(e.target.files).forEach((file) => {
        this.items.push({
          key: 'k' + seq++,
          file,
          preview: URL.createObjectURL(file),
          kind: 'Студия',
          area: '',
          price: '',
          discount: '',
          building: '',
          floor: '',
          view: '',
        });
      });
      e.target.value = '';
    },
    remove(i) {
      this.items.splice(i, 1);
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  margin-bottom: 8px;
}
.section {
  font-weight: 600;
  font-size: 13px;
  color: $muted;
  margin: 8px 0 10px;
}
.item {
  background: $bg-dark;
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 10px;
}
.head {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
}
.thumb {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  object-fit: cover;
  background: $white;
  flex: 0 0 auto;
}
.headtext {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.caption {
  font-weight: 600;
  font-size: 13px;
  color: $white;
}
.remove {
  background: transparent;
  border: none;
  color: $red;
  font-size: 12px;
  padding: 4px 0;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.lbl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  span {
    font-size: 10px;
    color: $muted;
  }
}
.full {
  grid-column: 1 / -1;
}
.inp {
  width: 100%;
  background: $background;
  border: 1px solid #3a3a3a;
  border-radius: 10px;
  color: $white;
  padding: 9px 10px;
  font-size: 13px;
  outline: none;
}
.custom {
  margin: 4px 0 16px;
}
.custom_button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 0;
  border: 1px dashed #4a4a4a;
  border-radius: 12px;
  color: $white;
  font-size: 12px;
  font-weight: 600;
}
.img {
  width: 14px;
  height: 14px;
}
.hidden {
  display: none;
}
</style>
